import Tag from "@/shared/data-display/tag";
import { ToolOutlined } from "@ant-design/icons";
import { AiAssistantToolCallFragment } from "gql/graphql";

/**
 * Инструменты, которыми ассистент сходил в данные компании по дороге к ответу.
 * Имена приходят с бэкенда техническими, показываем как есть.
 */
export function ToolCalls({
  toolCalls,
}: {
  toolCalls: AiAssistantToolCallFragment[];
}) {
  if (!toolCalls.length) {
    return null;
  }

  return (
    <div className={"flex flex-wrap gap-1 mb-2"}>
      {toolCalls.map(({ tool }, index) => (
        <Tag
          key={`${tool}-${index}`}
          icon={<ToolOutlined />}
          className={"!mr-0"}
        >
          {tool}
        </Tag>
      ))}
    </div>
  );
}
